import React from 'react';

import { notification, Modal, Row, Col, Button, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { graphql, compose, withApollo } from 'react-apollo';
import _ from 'lodash';
import moment from 'moment';

import { descargarCSV } from '../../administracion/funciones/descargarCSV';

import getNovedades from '../../../graphql/querys/rrhh/getNovedades.graphql';
import TablaNovedades from './TablaNovedades';
import deleteNovedad from '../../../graphql/mutations/rrhh/deleteNovedad.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

import getNovedadesConFiltros from '../../../graphql/querys/rrhh/getNovedadesConFiltros.graphql';
import getCantidadNovedadesPorFiltros from '../../../graphql/querys/rrhh/getCantidadNovedadesPorFiltros.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismosFast.graphql';
import getMedidas from '../../../graphql/querys/otros/getMedidas.graphql';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(deleteNovedad, {
    name: 'deleteNovedad',
    options: {
      refetchQueries: [{ query: getNovedades }],
    },
  })
)
class VerNovedades extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      lista: [],
      filtroUsuario: null,
      filtroMedida: null,
      filtroOrganismo: null,
      filtroFechaDesde: null,
      filtroFechaHasta: null,
      sortField: null,
      sortOrder: null,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      listaOrganismos: [],
      listaMedidas: [],
    };
  }

  componentDidMount() {
    this.buscarCantidadNovedades();
    this.props.client
      .query({ query: getOrganismos, fetchPolicy: 'network-only' })
      .then(res => {
        if (res.data.getOrganismos) {
          this.setState({ listaOrganismos: res.data.getOrganismos });
        }
      })
      .catch(err => console.log('Error al buscar organismos', err));
    this.props.client
      .query({ query: getMedidas, fetchPolicy: 'network-only' })
      .then(res => {
        if (res.data.getMedidas) {
          this.setState({ listaMedidas: res.data.getMedidas });
        }
      })
      .catch(err => console.log('Error al buscar medidas', err));
  }

  buscarCantidadNovedades = () => {
    this.props.client
      .query({
        query: getCantidadNovedadesPorFiltros,
        variables: {
          filtros: {
            textoUsuario: this.state.filtroUsuario,
            tipoMedida: this.state.filtroMedida,
            idOrganismo: this.state.filtroOrganismo,
            fechaDesde: this.state.filtroFechaDesde,
            fechaHasta: this.state.filtroFechaHasta,
          },
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        this.setState(
          {
            cantidadTotal: res.data.getCantidadNovedadesPorFiltros,
          },
          () => {
            this.lanzarconsulta();
          }
        );
      })
      .catch(err => {
        console.log('Error al buscar la cantidad total de novedades');
        console.log(err);
        errorService(err, { filtros: {} });
      });
  };

  lanzarconsulta = () => {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getNovedadesConFiltros,
        variables: {
            filtros: {
              textoUsuario: this.state.filtroUsuario,
              tipoMedida: this.state.filtroMedida,
              idOrganismo: this.state.filtroOrganismo,
              fechaDesde: this.state.filtroFechaDesde,
              fechaHasta: this.state.filtroFechaHasta,
            },
            pagina: this.state.pagina,
            cantidadPorPagina: this.state.cantidadPorPagina,
            sortField: this.state.sortField,
            sortOrder: this.state.sortOrder,
          },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        if (res.data.getNovedadesConFiltros) {
          this.setState({
            lista: res.data.getNovedadesConFiltros,
            loading: false,
          });
        }
      })
      .catch(err => {
        console.log('Error al buscar novedades: ', err);
        notification.error({
          message: 'Error a la hora de buscar las novedades',
        });
        this.setState({ loading: false });
      });
  };

  setFiltroUsuario = async filtro => {
    this.setState(
      { filtroUsuario: filtro.textoUsuario, pagina: 1, loading: true },
      () => this.buscarCantidadNovedades()
    );
  };

  setFiltroOrganismo = idOrganismo => {
    this.setState(
      { filtroOrganismo: idOrganismo || null, pagina: 1, loading: true },
      () => this.buscarCantidadNovedades()
    );
  };

  setFiltroMedida = tipoMedida => {
    this.setState(
      { filtroMedida: tipoMedida || null, pagina: 1, loading: true },
      () => this.buscarCantidadNovedades()
    );
  };

  setFiltroFecha = ({ fechaDesde, fechaHasta }) => {
    this.setState(
      { filtroFechaDesde: fechaDesde || null, filtroFechaHasta: fechaHasta || null, pagina: 1, loading: true },
      () => this.buscarCantidadNovedades()
    );
  };

  setSort = (sortField, sortOrder) => {
    this.setState(
      { sortField: sortField || null, sortOrder: sortOrder || null, pagina: 1 },
      () => this.lanzarconsulta()
    );
  };

  cambiarPagina = pagina => {
    this.setState({ pagina }, () => {
      this.lanzarconsulta();
    });
  };

  onDescargarCSV = () => {
    this.setState({ loading: true });
    this.props.client
      .query({
        query: getNovedadesConFiltros,
        variables: {
          filtros: {
            textoUsuario: this.state.filtroUsuario,
            tipoMedida: this.state.filtroMedida,
            idOrganismo: this.state.filtroOrganismo,
            fechaDesde: this.state.filtroFechaDesde,
            fechaHasta: this.state.filtroFechaHasta,
          },
          pagina: 1,
          cantidadPorPagina: this.state.cantidadTotal || 10000,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        const novedades = res.data.getNovedadesConFiltros || [];
        const data = novedades.map(nov => ({
          usuario: nov.usuario ? `${nov.usuario.nombre} ${nov.usuario.apellido}` : '',
          organismo: nov.organismo ? nov.organismo.nombre : '',
          tipoMedida: nov.tipoMedida || '',
          fechaDesde: nov.fechaDesde ? moment(nov.fechaDesde).format('DD/MM/YYYY HH:mm') : '',
          fechaHasta: nov.fechaHasta ? moment(nov.fechaHasta).format('DD/MM/YYYY HH:mm') : '',
          observaciones: nov.observaciones || '',
          fechaCreacion: nov.fechaCreacion ? moment(nov.fechaCreacion).format('DD/MM/YYYY HH:mm') : '',
        }));
        descargarCSV(
          ['USUARIO', 'ORGANISMO', 'TIPO DE MEDIDA', 'FECHA DESDE', 'FECHA HASTA', 'OBSERVACIONES', 'FECHA CREACIÓN'],
          data,
          `Novedades-${moment().format('DD-MM-YYYY')}.csv`
        );
        this.setState({ loading: false });
      })
      .catch(err => {
        console.log('Error al descargar novedades CSV: ', err);
        notification.error({ message: 'Error al generar el archivo CSV' });
        this.setState({ loading: false });
      });
  };

  onDelete = id => {
    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta novedad?',
      content: 'Esta acción no podrá deshacerse',
      onOk() {
        yo.props
          .deleteNovedad({
            variables: { _id: id },
          })
          .then(res => {
            let id = res.data.deleteNovedad;
            if (id) {
              notification.warning({
                message: 'Novedad eliminada',
                description: 'Se ha eliminado la novedad exitosamente',
              });
              yo.buscarCantidadNovedades();
            }
          })
          .catch(err => {
            console.log('Error al eliminar la novedad');
            console.log(err);
            Modal.error({
              title: 'Error en la eliminación de la novedad',
              content:
                'Lamentamos informarle que la operación que intentó realizar, no se llevó a cabo por un error interno. Si el error persiste, comuníquese con el departamento de informática para obtener más detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  render() {
    const { listaOrganismos, listaMedidas, filtroFechaDesde, filtroFechaHasta } = this.state;
    return (
      <div>
        <h1 className="tituloForm">Novedades</h1>
        <Row style={{ marginBottom: 12 }} align="middle" justify="space-between">
          <Col>
            <span style={{ marginRight: 8, fontSize: 13 }}>Desde:</span>
            <DatePicker
              size="small"
              format="DD-MM-YYYY"
              placeholder="Fecha inicio"
              value={filtroFechaDesde ? moment(filtroFechaDesde) : null}
              onChange={val =>
                this.setFiltroFecha({
                  fechaDesde: val ? val.startOf('day').toDate() : null,
                  fechaHasta: filtroFechaHasta,
                })
              }
              style={{ marginRight: 16 }}
            />
            <span style={{ marginRight: 8, fontSize: 13 }}>Hasta:</span>
            <DatePicker
              size="small"
              format="DD-MM-YYYY"
              placeholder="Fecha fin"
              value={filtroFechaHasta ? moment(filtroFechaHasta) : null}
              onChange={val =>
                this.setFiltroFecha({
                  fechaDesde: filtroFechaDesde,
                  fechaHasta: val ? val.endOf('day').toDate() : null,
                })
              }
            />
          </Col>
          <Col>
            <Button
              icon={<Icons.DownloadOutlined />}
              onClick={this.onDescargarCSV}
              loading={this.state.loading}
              disabled={this.state.cantidadTotal === 0}
            >
              Descargar CSV
            </Button>
          </Col>
        </Row>
        <TablaNovedades
          novedades={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          setFiltroUsuario={this.setFiltroUsuario}
          filtroUsuarioPadre={this.state.filtroUsuario}
          setFiltroOrganismo={this.setFiltroOrganismo}
          filtroOrganismoPadre={this.state.filtroOrganismo}
          setFiltroMedida={this.setFiltroMedida}
          filtroMedidaPadre={this.state.filtroMedida}
          setFiltroFecha={this.setFiltroFecha}
          filtroFechaDesde={this.state.filtroFechaDesde}
          filtroFechaHasta={this.state.filtroFechaHasta}
          setSort={this.setSort}
          listaOrganismos={listaOrganismos}
          listaMedidas={listaMedidas}
          cambiarPagina={this.cambiarPagina}
          tamPagina={this.state.cantidadPorPagina}
          total={this.state.cantidadTotal}
          loadingTabla={this.state.loading}
          pagina={this.state.pagina}
        />
      </div>
    );
  }
}

export default withApollo(VerNovedades);
